import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as React from 'react';

import { FILTERS } from '../../constants/filters';
import { dealTypeFromJsonQuery, offerTypeFromJsonQuery } from '../../utils/category';
import { FiltersSearchButtonContainer } from '../../containers/FiltersSearchButtonContainer';
import { getFiltersList } from './helpers';
import * as styles from './Filters.css';

export interface IFiltersProps {
  jsonQuery: IJsonQuery;
}

export class Filters extends React.Component<IFiltersProps> {
  public render() {
    const { jsonQuery } = this.props;
    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const offerType = offerTypeFromJsonQuery(jsonQuery);

    const filters = getFiltersList(dealType, offerType);

    return (
      <div className={styles['container']} data-mark="Filters">
        <div className={styles['wrapper']}>
          {filters.map((filterName) => {
            const filter = FILTERS[filterName];
            const { component: Component } = filter;

            return (
              <Component
                key={`filter_${filterName}`}
                dealType={dealType}
                offerType={offerType}
              />
            );
          })}
        </div>
        <FiltersSearchButtonContainer />
      </div>
    );
  }
}
